import { createClassModuleFactory } from "../../ui/factories/module-factory-helpers.js";

const accountModuleLoader = () => import('./AccountModule.js');
const accountModuleFactory = createClassModuleFactory(accountModuleLoader, 'AccountModule');

export const routes = [

    // -------------------------------------------------------------------------------------------- Public

    {
        // AccountModule.ROUTE_REGISTRATION
        name: 'account-registration',
        path: '/account/registration',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'registration' }
    },
    {
        // AccountModule.ROUTE_REGISTRATION_SUCCESS
        name: 'account-registration-success',
        path: '/account/registration/success',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'registration-success' }
    },
    {
        // AccountModule.ROUTE_PASSWORD_RESET_START
        name: 'account-password-reset-start',
        path: '/account/password-reset-start',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'password-reset-start' }
    },
    {
        // AccountModule.ROUTE_PASSWORD_RESET_START_SUCCESS
        name: 'account-password-reset-start-success',
        path: '/account/password-reset-start/success',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'password-reset-start-success' }
    },
    {
        // AccountModule.ROUTE_PASSWORD_RESET
        name: 'account-password-reset',
        path: '/account/password-reset',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'password-reset' }
    },
    {
        // AccountModule.ROUTE_PASSWORD_RESET_SUCCESS
        name: 'account-password-reset-success',
        path: '/account/password-reset/success',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'password-reset-success' }
    },
    {
        // AccountModule.ROUTE_EMAIL_VERIFICATION
        name: 'account-email-verification',
        path: '/account/email-verification',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'email-verification' }
    },
    {
        // AccountModule.ROUTE_EMAIL_VERIFICATION_SUCCESS
        name: 'account-email-verification-success',
        path: '/account/email-verification/success',
        factory: accountModuleFactory,
        public: true,
        options: { mode: 'email-verification-success' }
    },

    // -------------------------------------------------------------------------------------------- Private

    {
        // AccountModule.ROUTE_ACCOUNT_DETAILS
        name: 'account-account-details',
        path: '/account/details',
        factory: accountModuleFactory,
        options: { mode: 'account-details' }
    },

];
